import { render, staticRenderFns } from "./ShiftsTab.vue?vue&type=template&id=32040cb2&scoped=true"
import script from "./ShiftsTab.vue?vue&type=script&lang=js"
export * from "./ShiftsTab.vue?vue&type=script&lang=js"
import style0 from "./ShiftsTab.vue?vue&type=style&index=0&id=32040cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32040cb2",
  null
  
)

export default component.exports